export default __webpack_public_path__ + "static/premio_exclusivo-EC-cfde92f50f63165c1c271ebca8c8e248.png";